export class PaperlessService {
    private static endpoint = '/apic/paperlesspreference';

    public getPreference = async (): Promise<boolean> => {
        const response = await fetch(PaperlessService.endpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET'
        });
        return await response.json() as boolean;
    };

    public setPreference = async (isPaperless: boolean): Promise<void> => {
        await fetch(PaperlessService.endpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(isPaperless)
        });
    }
}